import { FieldCurrencyTypes } from 'pricing/types';
import number from 'utilities/number/number';

export const costValidation = (type: FieldCurrencyTypes) => {
  const breederMinCost = '450';

  return {
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject('This field is required');
      }

      if (value < breederMinCost) {
        return Promise.reject(
          `${type} is under the minimum ${number.formatterCurrency(breederMinCost)}`,
        );
      }

      return Promise.resolve();
    },
  };
};
